import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const PrivateRoute = ({ children }) => {
    const { isLoggedIn, loading } = useAuth();

    if (loading) {
        return null; // or a loading spinner
    }

    return isLoggedIn ? children : <Navigate to="/" />;
};

export default PrivateRoute;
